import { PiWarningCircle } from "react-icons/pi";
import { RxCross2 } from "react-icons/rx";
import { PiWarningBold } from "react-icons/pi";
import { IoBookOutline } from "react-icons/io5";
import { BiComment } from "react-icons/bi";
import { PiNote } from "react-icons/pi";
import { GrBook } from "react-icons/gr";
import { TbTemplate } from "react-icons/tb";
import { GrStatusGood } from "react-icons/gr";
import { IoSparkles } from "react-icons/io5";

export const TemplateIcon = ({ className = "", size = 21, color }) => {
  return <TbTemplate className={className} size={size} color={color} />;
};

// used in error message for inputs and other places risk tasks
export const WarningIcon = ({ className = "", size = 21, color,variant="circle" }) => {
  if(variant==="triangle"){
    return <PiWarningBold className={className} size={size} color={color} />;
  } 
  return <PiWarningCircle className={className} size={size} color={color} />;
};

// used in closing tasks and other places where you need to show a cross icon
export const CrossIcon = ({ className = "", size = 21, color }) => {
  return <RxCross2 className={className} size={size} color={color} />;
};

export const BookIcon = ({ className = "", size = 21, color, variant }) => {
  // this is one side outline icon
  if (variant === "GrBook") {
    return <GrBook className={className} size={size} color={color} />;
  }
  // default is outline icon 2 pages
  return <IoBookOutline className={className} size={size} color={color} />;
}

export const CommentIcon = ({ className = "", size = 21, color }) => {
  return <BiComment className={className} size={size} color={color} />;
};

export const NoteIcon = ({ className = "", size = 21, color }) => {
  return <PiNote style={{ transform: "scaleY(-1)" }} className={className} size={size} color={color} />;
}

export const GoodIcon = ({ className = "", size = 21, color }) => {
  return <GrStatusGood className={className} size={size} color={color} />;
}

export const SparklesIcon = ({ className = "", size = 21, color }) => {
  return <IoSparkles className={className} size={size} color={color} />;
}